import { useQuery } from '@tanstack/react-query'
import { fetchAlternatingVideos } from '../services/youtubeService'

export default function HomePage() {
  const { data: videos, isLoading, error } = useQuery({
    queryKey: ['youtube-feed'],
    queryFn: () => fetchAlternatingVideos(3),
    staleTime: 1000 * 60 * 30, // 30 minutes
    gcTime: 1000 * 60 * 60 // 1 hour
  })

  return (
    <div className="max-w-6xl mx-auto">
      {isLoading && (
        <div className="text-center py-12">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          <p className="mt-4 text-gray-600">Loading videos...</p>
        </div>
      )}

      {error && (
        <div className="text-center py-12">
          <p className="text-red-600">Failed to load videos. Please check your YouTube API configuration.</p>
        </div>
      )}

      {videos && videos.length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {videos.map((video) => (
            <div key={video.id} className="rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="relative" style={{ paddingBottom: '56.25%' }}>
                <iframe
                  className="absolute top-0 left-0 w-full h-full"
                  src={`https://www.youtube.com/embed/${video.id}`}
                  title={video.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          ))}
        </div>
      )}

      {videos && videos.length === 0 && !isLoading && (
        <div className="text-center py-12">
          <p className="text-gray-600">No videos available at the moment.</p>
        </div>
      )}
    </div>
  )
}
